import {
  INSIGHTS_IMPORT_QUEUE_DISMISSALS_MAX,
  INSIGHTS_IMPORT_QUEUE_DISMISSALS_STORAGE_KEY,
} from '../constants/insights-import-queue-dismissals-storage-key';

function parseDismissedIds(raw: string | null): Set<string> {
  if (!raw) return new Set();
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter((id): id is string => typeof id === 'string'));
  } catch {
    return new Set();
  }
}

export function readDismissedInsightImportIds(): Set<string> {
  if (typeof window === 'undefined') return new Set();
  return parseDismissedIds(
    window.localStorage.getItem(INSIGHTS_IMPORT_QUEUE_DISMISSALS_STORAGE_KEY)
  );
}

export function writeDismissedInsightImportIds(ids: Set<string>): void {
  if (typeof window === 'undefined') return;
  const trimmed = [...ids].slice(-INSIGHTS_IMPORT_QUEUE_DISMISSALS_MAX);
  window.localStorage.setItem(
    INSIGHTS_IMPORT_QUEUE_DISMISSALS_STORAGE_KEY,
    JSON.stringify(trimmed)
  );
}

export function mergeDismissedInsightImportIds(
  newIds: Iterable<string>
): Set<string> {
  const merged = readDismissedInsightImportIds();
  for (const id of newIds) merged.add(id);
  if (merged.size > INSIGHTS_IMPORT_QUEUE_DISMISSALS_MAX) {
    const trimmed = [...merged].slice(-INSIGHTS_IMPORT_QUEUE_DISMISSALS_MAX);
    const next = new Set(trimmed);
    writeDismissedInsightImportIds(next);
    return next;
  }
  writeDismissedInsightImportIds(merged);
  return merged;
}
